import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";

const STEPS = [
  {
    title: "도구 선택",
    desc: "Cover, Training, TTS, 작곡, 이미지, 영상까지. 6개 카테고리 중 원하는 AI 도구를 고르세요.",
  },
  {
    title: "소스 입력",
    desc: "음원, 텍스트, 보이스 모델, 작곡/작사 아이디어\n가진 무엇이든 편하게 넣어주세요.",
  },
  {
    title: "AI 생성",
    desc: "몇 분이면 스튜디오 퀄리티의 결과물이 완성됩니다.",
  },
];

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#0d0d0d",
    padding: "96px 32px",
    borderTop: "1px solid #161616",
    borderBottom: "1px solid #161616",
    "@media (max-width:600px)": { padding: "64px 24px" },
  },
  inner: { maxWidth: 1280, margin: "0 auto" },
  miniLabel: {
    fontSize: 12,
    fontWeight: 600,
    letterSpacing: "1.5px",
    textTransform: "uppercase",
    color: "#555",
    marginBottom: 16,
  },
  headline: {
    fontSize: 40,
    fontWeight: 700,
    letterSpacing: "-1.5px",
    lineHeight: 1.15,
    color: "#fff",
    margin: 0,
    marginBottom: 64,
    "@media (max-width:600px)": { fontSize: 30 },
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    position: "relative",
    "@media (max-width:900px)": { gridTemplateColumns: "1fr" },
  },
  step: {
    padding: "0 40px",
    display: "flex",
    flexDirection: "column",
    gap: 20,
    position: "relative",
    "&:not(:last-child)": {
      borderRight: "1px solid #1e1e1e",
      "@media (max-width:900px)": {
        borderRight: "none",
        borderBottom: "1px solid #1e1e1e",
        paddingBottom: 32,
        marginBottom: 32,
      },
    },
    "&:first-child": { paddingLeft: 0 },
    "&:last-child": { paddingRight: 0 },
    "@media (max-width:900px)": { padding: 0 },
  },
  num: {
    width: 56,
    height: 56,
    borderRadius: "50%",
    border: "1px solid #2a2a2a",
    background: "#111",
    fontSize: 13,
    fontWeight: 700,
    color: theme.palette.primary.main,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    letterSpacing: "0.5px",
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    letterSpacing: "-0.5px",
    color: "#fff",
    margin: 0,
  },
  desc: {
    fontSize: 15,
    lineHeight: 1.65,
    color: "#666",
    margin: 0,
    whiteSpace: "pre-line",
  },
}));

export default function Process() {
  const classes = useStyles();
  return (
    <Box component="section" className={classes.root}>
      <Box className={classes.inner}>
        <Typography className={classes.miniLabel}>Process</Typography>
        <Typography component="h2" className={classes.headline}>
          Three steps,
          <br />
          any AI content.
        </Typography>

        <Box className={classes.grid}>
          {STEPS.map((s, i) => (
            <Box key={s.title} className={classes.step}>
              <Box className={classes.num}>
                {String(i + 1).padStart(2, "0")}
              </Box>
              <Typography className={classes.title}>{s.title}</Typography>
              <Typography className={classes.desc}>{s.desc}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
}
